import { EnumDataItemInterface } from "@nts/std/interfaces";
import { Expose } from "@nts/std/serialization";

export class EnumDataItem implements EnumDataItemInterface {
    
    @Expose()
    enumValue: number;
    
    @Expose()
    enumDisplayName: string;
}